<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/az/azsocieties"
    >
        <template v-slot:headline="{ data }">
            <div 
                class="headline"
                :alvqa="alvqa + '-title'"
            >
            {{  
                data.societyName
            }}
            </div>
        </template>

        <template v-slot:editForm="{ data }">
            <v-col cols="1">
                <v-row>
                    <v-col>
                        <v-img 
                            v-if="data.pictureBig !== null"
                            :src="data.pictureBig"
                        ></v-img>
                        <v-img
                            v-else
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <!-- <BaseIcon 
                                    @click="uploadPicture()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_CAPTION_UPLOAD_IMAGE"
                                />   -->
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col> 

            <v-col cols="7">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Name"
                        :label="$t('lang_GENERAL_CAPTION_SOCIETY')" 
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-name'"
                    />
                </v-row>
                 <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRowOne"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')" 
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-address-row-one'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Zip"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-zip'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="City"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CITY')"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-city'"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Country"
                        :items="countries" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"  
                        :disabled="true"
                        :alvqa="alvqa + '-dropdown-country'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context"
                        field="Notes"
                        rows="3"
                        :label="$t('lang_GENERAL_CAPTION_NOTES')"
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col>
            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_GENERIC_CAPTION_ALVID')"
                        :clearable="false"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-alvid'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Currency"
                        :items="dropdownCurrency" 
                        :clearable="false"
                        :label="$t('lang_GENERIC_CAPTION_CURRENCY')"
                        :disabled="true"
                        :alvqa="alvqa + '-dropdown-invoice-currency'"
                    /> 
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="MembershipId"
                        :iconTooltipText="$t('lang_AZ_SOCIETIES_TOOLTIP_MEMBERSHIP_ID')"
                        :label="$t('lang_AZ_SOCIETY_MEMBERSHIP_ID')"
                        :alvqa="alvqa + '-textfield-membership-id'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Visibility"
                        :items="visibilityItems" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_VISIBILITY')"
                        :clearable=false
                        :alvqa="alvqa + '-dropdown-visibility'" 
                    />
                </v-row>
            </v-col>
        </template>
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'

import { DropdownCurrencies } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "AzSocietiesEdit",
    components: {
        BaseEditPage,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageTextarea
    },
    data() {
        return {
            context: "AzSocieties",
            alvqa: "az-societies-edit-form"
        }
    },
    computed: {
        countries()             { return this.$alvPlugin.getListOfTranslatedCountries() },
        dropdownCurrency()      { return DropdownCurrencies },
        visibilityItems() { 
            let visibilityArr
            let visibility = this.$store.getters['getVisibility' + this.$i18n.locale.toUpperCase()] 
            if(visibility === undefined) visibility = this.$store.getters.getVisibilityEN // fallback EN

            if(visibility !== undefined) {
                visibilityArr = JSON.parse(JSON.stringify(visibility))
                visibilityArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-visibility-' + element.value
                });
            } else {
                visibilityArr = []
            }

            return visibilityArr
        },
    },
    mounted() {
        this.$store.commit('setCountries')
        this.$store.commit('setVisibility')
    },
}
</script>